import { WithStyles, withStyles } from '@mui/styles';

import { Offline } from './offline';
import { muiStyles } from './styles';

export type OfflineProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(Offline);